import i18n from "i18next";
import {
	ProductChangeForm,
	ProductChangeFormProps
} from "src/components/views/erp/productChanges/changes/ProductChangeForm.tsx";
import {
	DocumentsOfSingleObjectView
} from "src/components/views/documents/objectDocuments/DocumentsOfSingleObjectView.tsx";
import {
	ProductChangeLinkedRequestsTab
} from "src/components/views/erp/productChanges/changes/linkedRequests/ProductChangeLinkedRequestsTab.tsx";
import { ProductChangeCatalogPartRevisionsDataGrid } from "./revisions/ProductChangeCatalogPartRevisionsDataGrid.tsx";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { ObjectChangeLogDataGrid } from "src/components/views/changeLogging/ObjectChangeLogDataGrid.tsx";
import { WorkspacesView } from "src/components/views/workspaces/WorkspacesView.tsx";
import { SingleSourceTasksView } from "src/components/views/tasks/pages/SingleSourceTasksView.tsx";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { useTasksEnabled } from "src/components/views/tasks/useTasksEnabled.ts";

export interface ProductChangeDialogProps extends Omit<ProductChangeFormProps, "connectToRequests" | "productChangeId"> {
	productChangeId: number;
}

export const ProductChangeDialog = ({ productChangeId, onCompleted, onFormEdited }: ProductChangeDialogProps) => {
	const { tenantConfig } = useTenantCustomizations();
	const tasksEnabled = useTasksEnabled();
	return (
		<AavoMosaic
			layout={{
				type: "tabs",
				items: [
					{
						type: "panel",
						title: i18n.t("basic_information"),
						content: (
							<ProductChangeForm
								productChangeId={productChangeId}
								onFormEdited={onFormEdited}
								onCompleted={onCompleted}
							/>
						),
					},
					tenantConfig.documentsEnabled && {
						type: "panel",
						title: i18n.t("documents"),
						content: (
							<DocumentsOfSingleObjectView
								objectRef={{
									objectType: "PRODUCT_CHANGE",
									objectId: productChangeId,
								}}
								editable={true}
							/>
						),
					},
					tasksEnabled && {
						type: "panel",
						title: i18n.t("tasks"),
						content: (
							<SingleSourceTasksView
								taskSourceRef={{
									sourceType: "PRODUCT_CHANGE",
									sourceId: productChangeId,
								}}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("product_change_requests"),
						content: <ProductChangeLinkedRequestsTab productChangeId={productChangeId} />,
					},
					{
						type: "panel",
						title: i18n.t("catalog_part_revisions"),
						content: <ProductChangeCatalogPartRevisionsDataGrid productChangeId={productChangeId} />,
					},
					tenantConfig.workspacesEnabled && {
						type: "panel",
						title: i18n.t("workspaces"),
						content: (
							<WorkspacesView
								onlyWorkspacesConnectedToItem={{
									itemId: productChangeId,
									itemType: "PRODUCT_CHANGE",
								}}
							/>
						),
					},
					{
						type: "panel",
						title: i18n.t("change_log"),
						content: (
							<ObjectChangeLogDataGrid
								objectRef={{
									objectType: "PRODUCT_CHANGE",
									objectId: productChangeId,
								}}
							/>
						),
					},
				],
			}}
		/>
	);
};
